import { Component, OnInit } from '@angular/core';
import { Services1Service } from '../services/services1.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {

  constructor(
    private service1:Services1Service
    ) { }

  ngOnInit(): void {}

/*   setLoginDisplay(){
    return this.service1.loginDisplay;
  }
 */
  openBuild(){
    this.service1.openBuild();
   }

 /*   openBuild_libre(){
    this.service1.openBuild_libre();
   }  */
}
